import { useState } from "react";
import GroupItem from "../GroupItem";
import { FaCheck } from "react-icons/fa";
import { createGroup } from "../../../services/groupService";

export default function GroupSettings({
  groups,
  setGroups,
  setStudentNoGroup,
}) {
  const [newGroupState, setNewGroupState] = useState("");

  function handleSubmit() {
    if (!newGroupState.trim()) {
      alert("Le nom du groupe ne peut pas être vide.");
      return;
    }
    if (groups[newGroupState]) {
      alert("Ce groupe existe déjà.");
      return;
    }
    createGroup(newGroupState)
      .then((response) => {
        setGroups((prev) => ({
          ...prev,
          [response.data.groupName]: {
            id: response.data.id,
            juries: [],
            students: [],
          },
        }));
        setNewGroupState("");
      })
      .catch((error) => {
        console.error(error);
      });
  }
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col items-center">
        <label htmlFor="newGroup" className="text-white">
          Nom du nouveau groupe
        </label>
        <input
          className="border border-black p-1 w-full"
          type="text"
          name="newGroup"
          id="newGroup"
          value={newGroupState}
          onChange={(e) => setNewGroupState(e.target.value)}
        />
      </div>
      <button
        className="self-end w-8 h-8 bg-primary-validate mr-2 pt-1 flex items-center justify-center rounded border hover:bg-secondary-validate"
        onClick={handleSubmit}
      >
        <FaCheck className="text-white w-4 h-4" />
      </button>

      {Object.keys(groups).map((groupKey, index) => (
        <GroupItem
          groups={groups}
          setGroups={setGroups}
          setStudentNoGroup={setStudentNoGroup}
          groupKey={groupKey}
          key={index}
        />
      ))}
    </div>
  );
}
